import { Type } from "@angular/core";
import { FilterComponent } from './filter.component';

export * from "./filter.component";

export const FILTER_DIRECTIVES: Type<any>[] = [
    FilterComponent
];
